import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./report/report-content.jsx";

export default function Content({ reportData, data, entity, title, printComponentRef, setIsPrinting, visibleModules, printOptions }) {
    return (
        <>
            {reportData && data && (
                <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setIsPrinting}>
                    <div className="w-full mt-[25px] print:mt-0">
                        <ReportContent
                            data={reportData}
                            visibleModules={visibleModules}
                            printOptions={printOptions}
                        />
                    </div>
                </PrintTemplate>
            )}
        </>
    )
}